import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ViewOptions from './ViewOptions';
import Typography from '@material-ui/core/Typography';

function SelectedCountryDetails(props) {
	const { selectedCountryProperties: { countryName } } = props;
	// console.log('selectedCountryProperties',selectedCountryProperties);
	return (
		// <Card className="floatiang-card"
		// 	style={{
		// 		height: '10%',
		// 		// width: '340px',
		// 		bottom: '5px',
		// 		position: 'absolute',
		// 		right: '5px',
		// 		top: '15%',
		// 		zIndex: '1000',
		// 		display: 'flex',
        //         justifyContent: 'center',
        //         padding:'5px'

		// 	}}

		// >
			<div
				style={{
					display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
					flexFlow:'column',
					backgroundColor:'#007EA7',
					color:'white'
				}}
			>

				<Typography variant='h6' gutterBottom>
					{`Anthem played:`}
				</Typography>
                <Typography variant='h6' gutterBottom>
					{`${countryName}`}
				</Typography>
			</div>

		// </Card>
	)
}

const mapStateToProps = state => {
	const { songsReducers } = state;
	const {
		isCountrySelected,
		selectedCountryName,
		selectedCountryProperties
	} = songsReducers;
	return {
		selectedCountryName,
		selectedCountryProperties,
		isCountrySelected
	};
};


export default connect(mapStateToProps, null)(SelectedCountryDetails);